import { Component, OnInit,  Input } from '@angular/core';
import { DynamicWidget } from '../dynamic-widget';
import { FormPageConfig } from '../../../models/form-page-config';
import { LFDynamicWidgetConfig } from '../../../models/lf-dynamic-widget-config';
import { SearchableEntityDataService } from '../../../services/searchable-entity/searchable-entity-data.service';
import { SearchableEntityDataEditorService } from '../../../services/searchable-entity/searchable-entity-data-editor.service';
import { DetailViewKeyEventHandlerService } from '../../../services/detail-view-key-event-handler.service';
import { ResourceService } from 'sce-core';
import { DetailedEntityButtonService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { DetailedEntityDataService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data.service';

@Component({
  selector: 'lfwms-multi-tabbed-detail-table',
  templateUrl: './multi-tabbed-detail-table.html',
  styleUrls: ['./multi-tabbed-detail-table.css']
})
export class MultiTabbedDetailTableComponent implements OnInit, DynamicWidget {

  @Input() pageConfig: FormPageConfig;
  @Input() widgetConfig: LFDynamicWidgetConfig;
  public dataService: DetailedEntityDataService;
  public dataEditor: SearchableEntityDataEditorService;
  public keyEventHandler: DetailViewKeyEventHandlerService;
  protected buttonService: DetailedEntityButtonService;

  constructor(protected resourceService: ResourceService) {

  }

  public ngOnInit() {
    this.dataService = <DetailedEntityDataService> this.pageConfig.dataService;
    this.dataEditor = this.pageConfig.dataEditor;
    this.keyEventHandler = this.pageConfig.keyEventHandler;
    this.buttonService = <DetailedEntityButtonService> this.pageConfig.buttonService;
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public initializeDetailTable() {
    let loadFromServer = true;
    if (this.dataService.displayMode === 'C') {
      loadFromServer = false;
    } else if (this.dataService.detailsSearchService) {
      // if the data is already loaded
      if (this.dataService.detailsSearchService.searchStatus.hasResults) {
        loadFromServer = this.pageConfig.reloadDataOnTabChange;
      }
    }
    this.pageConfig.detailPageComponent.initializeDetailTable(loadFromServer);
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/multi-tabbed-detail-table/multi-tabbed-detail-table.ts